export const getDateRange = (startDate: Date, endDate: Date): Date[] => {
  const dates: Date[] = [];
  const current = new Date(startDate);

  while (current <= endDate) {
    dates.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }

  return dates;
};

export const getWeekStart = (date: Date, offset: number = 0): Date => {
  const day = date.getDay();
  const distanceToMonday = day === 0 ? -6 : 1 - day;

  const start = new Date(date);
  start.setDate(date.getDate() + distanceToMonday + offset * 7);
  start.setHours(0, 0, 0, 0);

  return start;
};

export const getWeekEnd = (date: Date, offset: number = 0): Date => {
  const start = getWeekStart(date, offset);

  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  end.setHours(23, 59, 59, 0);

  return end;
};

export const getWeekRange = (offset: number = 0) => {
  const now = new Date();

  return {
    offset,
    start: getWeekStart(now, offset),
    end: getWeekEnd(now, offset),
  };
};

export const getWeekOffset = (date: Date): number => {
  const now = new Date();

  const currentWeekStart = getWeekStart(now);
  const targetWeekStart = getWeekStart(date);

  const msInAWeek = 7 * 24 * 60 * 60 * 1000;

  return Math.round((targetWeekStart.getTime() - currentWeekStart.getTime()) / msInAWeek);
};

export const getTargetMonth = (targetMonth: number): Date => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();

  const distanceToTarget = targetMonth >= currentMonth ? targetMonth - currentMonth - 12 : targetMonth - currentMonth;

  const targetDate = new Date(currentDate);
  targetDate.setHours(0, 0, 0, 0);
  targetDate.setDate(1);
  targetDate.setMonth(targetDate.getMonth() + distanceToTarget);

  return targetDate;
};
